import { useCallback } from 'react';
import { ConfirmationDialog } from '@kinesis/bungle';
import { noop } from 'lodash/fp';

const ConnectorDeleteConfirmation = (
  props: ConnectorDeleteConfirmationProps,
) => {
  const { name, onDelete = noop, onClose = noop, animation = true } = props;
  const onConfirm = useCallback(() => {
    onDelete();
    onClose();
  }, [onDelete, onClose]);
  return (
    <ConfirmationDialog
      animation={animation}
      confirmText='Delete connector'
      cancelText='Keep connector'
      icon='exclamation'
      title={`Delete ${name}?`}
      onCancel={onClose}
      onConfirm={onConfirm}
      showCancelButton
      variant='danger'
      minWidth={320}
    >
      The connector using this client ID and secret will immediately lose
      access. Any tokens it holds will stop working.
    </ConfirmationDialog>
  );
};

export type ConnectorDeleteConfirmationProps = {
  name: string;
  onDelete?: () => void;
  onClose?: () => void;
  animation?: boolean;
};

export { ConnectorDeleteConfirmation };
